// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".project-info {\n  display: grid;\n  grid-template-columns: auto auto auto;\n  grid-gap: 1rem;\n  padding: 1rem 2rem;\n  background-color: #f5f5f5;\n  border-bottom: thin solid var(--primary-color);\n}\n.project-info__item {\n  padding: 1rem;\n}\n", ""]);
// Exports
module.exports = exports;
